import { Component, ViewChild, TemplateRef, Input, ElementRef, Renderer2, OnDestroy, AfterViewInit, OnInit, OnChanges } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { forkJoin } from 'rxjs';
import { PaginationService } from 'src/app/PaginationService';
import { ActivityGridComponent } from '../activity-grid/activity-grid.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';
import { EditorComponent } from 'src/app/editor/editor.component';

@Component({
  selector: 'app-raise-cc',
  templateUrl: './raise-cc.component.html',
  styleUrls: ['./raise-cc.component.scss']
})

export class RaiseCcComponent implements OnDestroy, AfterViewInit, OnInit, OnChanges {

  infoIconSrc: string = '../../assets/img/info-yellow.png';

  @Input() raiseComplaintData: boolean = false;
  @Input() isFromHomePage: any;
  @ViewChild('flexible', { static: false }) flexibleComponent!: FlexibleFieldsComponent;
  isProcessing: boolean = false;
  ccData: any = {};
  dateCustomClasses: DatepickerDateCustomClasses[];
  visibleComplaintGrid: boolean;
  freezeComplaintGroupDropDown: boolean;

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar, public message: messageService, private readonly elem: ElementRef,
    public qmsService: qmsService, public paginationService: PaginationService, private readonly activityGridComponent: ActivityGridComponent,
    public qmsservice: qmsService) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  ngOnChanges() {
    if (this.isFromHomePage) {
      this.qmsService.selectedGroup = 0;
      this.visibleComplaintGrid = true;
      this.getcallMethod();
    }
  }
  groupSearchText: string = "";
  titleSearchText: string = '';
  reporterTypeSearchText: string = '';
  reporterCountrySearchText: string = '';

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }


  @ViewChild('angularEditorTextarea', { static: true }) angularEditorTextarea: TemplateRef<any>;
  visibleAngularEditor: MatDialogRef<TemplateRef<any>>;

  angularEditorTextareaConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
  };
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  selectedCcGroup: any = null;
  selectedReporterTitle: any = null;
  selectedReporterType: any = null;
  selectedReporterCountry: any = null;

  dropDownForCcGroup: any = [];
  dropDownForReporterTitle: any = [];
  dropDownForReporterType: any = [];
  dropDownForReporterCountry: any = [];

  ccGroupDropDown: any = [];
  reporterTitleDropDown: any = [];
  reporterTypeDropDown: any = [];
  reporterCountryDropDown: any = [];

  label: any = [];
  dynamicLabel: any = null;
  groupIdForLabels: number = 0;
  getDynamicLabel(groupIdForLabels: number) {
    this.isProcessing = true;
    let groupId = groupIdForLabels == 1 ? 0 : groupIdForLabels;
    let resolvedGroupId;

    if (groupIdForLabels) {
      resolvedGroupId =
        (this.message.showComplaintSwitch && this.selectedCcGroup)
          ? this.selectedCcGroup
          : groupId;
    } else {
      resolvedGroupId = this.qmsservice.selectedGroup;
    }
    const data = {
      tableName: 'QMS_CC_GRID_VW',
      moduleName: 'CC',
      gridName: 'CC',
      groupId: resolvedGroupId
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.isProcessing = true;

    const getGroupsModuleCurrentUserVw$ = this.appService.getQmsGroupsByModule("CC");
    const getCodeListsByReporterTitle$ = this.appService.getCodeListsByGroup("COMPLAINT_REPORTER_TITLE");
    const getCodeListsByReporterType$ = this.appService.getCodeListsByGroup("COMPLAINT_REPORTER_TYPE");
    const getCodeListsByCountry$ = this.appService.getNonOrgCodeListsByGroupName("COUNTRY");
    this.groupIdForLabels = 0;

    forkJoin([
      getGroupsModuleCurrentUserVw$,
      getCodeListsByReporterTitle$,
      getCodeListsByReporterType$,
      getCodeListsByCountry$,
    ]).subscribe({
      next: ([groupsData, reporterTitleData, reporterTypeData, reporterCountryData]) => {

        this.dropDownForCcGroup = groupsData;
        this.selectBoxForCcGroup();
        if (this.message.showComplaintSwitch) {
          this.groupIdForLabels = 1;
          this.freezeComplaintGroupDropDown = false;
        } else {
          this.freezeComplaintGroupDropDown = true;
          this.groupIdForLabels = 0;
          if (this.raiseComplaintData) {
            this.selectedCcGroup = null;
          } else {
            const matchingGroup = this.dropDownForCcGroup.find((group: any) => group.groupId === this.qmsService.selectedActivityGroupId);
            if (matchingGroup) {
              this.selectedCcGroup = this.groupIdForLabels = matchingGroup.groupId;
            }
          }

        }
        this.ccData.reporterComments = null;
        this.ccData.isRiskCalculationReqd = this.qmsService.selectedGroupDetailData.isRiskCalculationReqd == 'Y';
        this.dropDownForReporterTitle = reporterTitleData;
        this.selectBoxForReporterTitle();

        this.dropDownForReporterType = reporterTypeData;
        this.selectBoxForReporterType();

        this.dropDownForReporterCountry = reporterCountryData;
        this.selectBoxForReporterCountry();

        setTimeout(() => { this.getDynamicLabel(this.groupIdForLabels); }, 2000);

        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
      }
    });
  }

  selectBoxForCcGroup() {
    this.ccGroupDropDown = [];
    this.ccGroupDropDown = this.dropDownForCcGroup?.map((item: { groupId: any; groupName: any; }) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  onCcGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('group-validation', item);
      if (item) {
        this.isProcessing = true;
        this.appService.getQmsGroupDetailsByModule(item?.valueExp, "CC").subscribe((data: any) => {
          if (data) {
            this.qmsService.selectedGroupDetailData = data;
            this.getDynamicLabel(this.groupIdForLabels);
            console.log(this.qmsService.selectedGroupDetailData);
          } else {
            this.selectedCcGroup = null;
            this.handleDropDownValidation('group-validation', false);
            this.showSnackBar("CC Module have not added in this group " + item.displayExp + " Please contact Administrator", 'E');
          }

          this.isProcessing = false;
        });
      }
    }
  }

  onCcGroupSelectOld() {
    this.isProcessing = true;
    this.appService.getQmsGroupDetailsByModule(this.selectedCcGroup[0]?.valueExp, "CC").subscribe((data: any) => {
      this.qmsService.selectedGroupDetailData = data;
      this.isProcessing = false;
    });
    this.handleDropDownValidation('group-validation', this.selectedCcGroup);
  }

  onCcGroupDeSelect() {
    this.handleDropDownValidation('group-validation', this.selectedCcGroup);
  }

  selectBoxForReporterTitle() {
    this.reporterTitleDropDown = [];
    this.reporterTitleDropDown = this.dropDownForReporterTitle.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  onReporterTitleSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('title-validation', item);
  }

  onReporterTitleSelectOld() {
    this.handleDropDownValidation('title-validation', this.selectedReporterTitle);
  }

  onReporterTitleDeSelect() {
    this.handleDropDownValidation('title-validation', this.selectedReporterTitle);
  }

  selectBoxForReporterType() {
    this.reporterTypeDropDown = [];
    this.reporterTypeDropDown = this.dropDownForReporterType.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  onReporterTypeSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('reporter-type-validation', item);
  }

  onReporterTypeSelectOld() {
    this.handleDropDownValidation('reporter-type-validation', this.selectedReporterType);
  }

  onReporterTypeDeSelect() {
    this.handleDropDownValidation('reporter-type-validation', this.selectedReporterType);
  }

  selectBoxForReporterCountry() {
    this.reporterCountryDropDown = [];
    this.reporterCountryDropDown = this.dropDownForReporterCountry.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  switchView() {
    this.visibleComplaintGrid = !this.visibleComplaintGrid;
    if (this.visibleComplaintGrid) {
      this.getcallMethod();
    } else {
      this.getDynamicLabel(this.groupIdForLabels);
      [
        this.selectedCcGroup,
        this.selectedReporterTitle,
        this.selectedReporterType,
        this.selectedReporterCountry
      ] = [null, null, null, null];
      this.ccData.reporterComments = null;
      this.ccData = {
        reporterFirstName: "",
        reporterMiddleName: "",
        reporterLastName: "",
        emailAddress: "",
        reporterDesignation: "",
        reporterContactNumber: "",
        reporterContactNumberOffice: "",
        reporterAddress1: "",
        reporterAddress2: "",
        reporterFax: "",
        reporterCity: "",
        reporterState: "",
        reporterZipcode: "",
        reporterComments: null
      }
    }
  }

  validateMobileNumber(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  validateZipCode(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '.', '+'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  validateAddress(event: Event) {
    const target = event.target as HTMLTextAreaElement;
    const textLength = target.value.length;

    if (textLength > 400) {
      this.showSnackBar("Maximum 400 Characters!", 'E');
      target.value = target.value.substring(0, 400);
    }
  }

  handleDropDownValidation(fieldId: string, selectedItems: any) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = !selectedItems && field ? 'red' : '#005c8a';
  }

  onNgModuleChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  editorValue: any;
  textareaEditorTitle: any;
  openEditor(value: string) {
    this.editorValue = this.ccData['reporterComments'];
    this.textareaEditorTitle = this.dynamicLabel['REPORTER_COMMENTS'].fieldName;
    this.visibleAngularEditor = this.dialog.open(this.angularEditorTextarea, this.angularEditorTextareaConfig);
  }

  okAngularEditorData(editorValue: any) {
    console.log(editorValue);
    this.ccData['reporterComments'] = this.editorValue;
    this.visibleAngularEditor.close();
  }

  cancelAngularEditorData() {
    this.visibleAngularEditor.close();
  }

  save(ccData: any) {
    const validations = [
      { condition: !this.selectedCcGroup, id: 'group-validation' },
      { condition: this.dynamicLabel['REPORTER_TITLE'].isRemovable != 'Y' && !this.selectedReporterTitle, id: 'title-validation' },
      { condition: !ccData.reporterFirstName, id: 'firstname-validation' },
      { condition: this.dynamicLabel['REPORTER_LAST_NAME'].isRemovable != 'Y' && !ccData.reporterLastName, id: 'lastname-validation' },
      { condition: this.dynamicLabel['REPORTER_TYPE'].isRemovable != 'Y' && !this.selectedReporterType, id: 'reporter-type-validation' },
      { condition: !ccData.reporterComments, id: 'comments' }
    ]
    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
      this.fieldValidation(invalidIds);
    } else {
      this.isProcessing = true;
      let data = {
        groupId: this.selectedCcGroup,
        reporterTitle: this.selectedReporterTitle,
        reporterFirstName: ccData.reporterFirstName,
        reporterMiddleName: ccData.reporterMiddleName,
        reporterLastName: ccData.reporterLastName,
        reporterType: this.selectedReporterType ? this.selectedReporterType : null,
        reporterDesignation: ccData.reporterDesignation,
        emailAddress: ccData.emailAddress,
        reporterContactNumber: ccData.reporterContactNumber,
        reporterContactNumberOffice: ccData.reporterContactNumberOffice,
        reporterAddress1: ccData.reporterAddress1,
        reporterAddress2: ccData.reporterAddress2,
        reporterFax: ccData.reporterFax,
        reporterCity: ccData.reporterCity,
        reporterState: ccData.reporterState,
        reporterCountry: this.selectedReporterCountry ? this.selectedReporterCountry : null,
        reporterZipcode: ccData.reporterZipcode,
        reporterComments: ccData.reporterComments,
        isRiskCalculationReqd: ccData.isRiskCalculationReqd ? "Y" : "N",
        raisedFrom: this.message.showComplaintSwitch ? "Raise" : "Manage",
      }
      this.appService.raiseComplaint(data).subscribe({
        next: (Response: any) => {
          this.message.lastmsg = Response;
          if (Response.resultType == 'S') {
            if (this.message.showComplaintSwitch) {
              this.visibleComplaintGrid = true;
              this.getcallMethod();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.qmsService.activityId = Response.ID;
              if (this.flexibleComponent.flexibleFields.length) { this.flexibleComponent.save('Master', +Response.ID); }
              this.activityGridComponent.getCall();
              this.activityGridComponent.visibleCcAddPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
              this.isProcessing = false;

            }
          } else {
            this.showSnackBar(Response.result, Response.resultType);
          }

          this.isProcessing = false;
        }
      });
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  cancel() {
    this.activityGridComponent.visibleCcAddPopup.close();
  }

  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  detailsData(list: any, index: any, event: Event, columnIndex: number) {

    if (columnIndex === 0) {
      this.message.activityId = list.CC_NO;
      this.qmsService.activityId = list.CC_NO;
      this.message.showLeftMenu = "Main";
      this.message.breadcrumbData.fourthLevel = list.CC_ID;
      this.qmsService.selectedActivityGroupId = this.qmsService.selectedGroup = list.GROUP_ID;
      this.qmsService.moduleName = "CC";
      const group = [{ valueExp: list.GROUP_ID, displayExp: list.GROUP_NAME }];
      this.qmsservice.groupNameAndValue = this.qmsservice.SelectedGroupNameAndValue = group;
      this.router.navigate(['dashboard/cc']);
    }
    event.stopPropagation();
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetpage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.isProcessing = true;
    const data = {

      gridName: "MY_CC",
      groupId: this.qmsService.selectedGroup
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_MY_CC_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const row of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    row[element.columnName] = row[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.grid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.grid) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.grid[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.previousSelectedValue = idx;
  }

  searchValue2: any;
  gridTemp: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, columnName);
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }

  public focusEmpty(): void {
    console.log();
  }

}
